import { createContext, useContext, useEffect, useReducer } from "react";
import {
  entriesReducer,
  INITIAL_STATE,
  types,
} from "../../reducers/inventory/entriesReducer";
import axios from "../../api/axios";
import { STATUS_NOT_LOADED } from "../../api/constant";
import { showTypeErrorFetch } from "../../utilities/alerts.utilities";
import { Link, useNavigate } from "react-router-dom";
const EntryIndexContext = createContext({});
const EntryIndexProvider = ({ children }) => {
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(entriesReducer, INITIAL_STATE);
  useEffect(() => {
    
      axios()
        .get(`inventory/getEntriesHeader`, {
          params: state.entries.filter,
        })
        .then(({ data }) => {
          dispatch({
            type: types.SET_ENTRIES_LOADED,
            payload: { elements: data.entries, rows: data.rows },
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    
  }, [state.entries.status,state.entries.filter.page]);
  //if change filter we have to reset page to getMovements
  useEffect(() => {
    if (state.entries.filter.page !== 1) {
      dispatch({
        type: types.SET_FILTER_ENTRY,
        payload: { field: "page", value: 1 },
      });
    } else {
      dispatch({
        type: types.RELOAD_ENTRIES_BY_FILTER,
      });
    }
  }, [
    state.entries.filter.types_detail,
    state.entries.filter.warehouse_id,
    state.entries.filter.types_detail,
    state.entries.filter.created_at,
    state.entries.filter.date_movement,
    state.entries.filter.order_number,
    state.entries.filter.nit,
    state.entries.filter.provider,
    state.entries.filter.status_ids


  ]);

  const loadEntry = (entry_id)=>
  {
    navigate(`/inventory/entry/${entry_id}`)
  }

  return (
    <EntryIndexContext.Provider value={[state, dispatch, { loadEntry }]}>
      {children}
    </EntryIndexContext.Provider>
  );
};
const useEntries = () => useContext(EntryIndexContext)[0];
const useDispatchEntryIndex = () => useContext(EntryIndexContext)[1];
const useActionsEntries = () => useContext(EntryIndexContext)[2];

export {
  EntryIndexContext,
  useEntries,
  useDispatchEntryIndex,
  useActionsEntries,
};
export default EntryIndexProvider;
